<template><div><h1>VUX V2.1.1Rc.14 发布日志</h1>
<h2><a href="/zh-CN/components/checker.html">Checker</a></h2>
<ul><li>[enhance] 不可选项同样触发事件 on-item-click #1144</li>
</ul>
<h2><a href="/zh-CN/components/form-preview.html">FormPreview</a></h2>
<ul><li>[fix] 修复 less 变量：form-preview-button-primary-color</li>
<li>[feature] 支持 prop:name 以方便函数调用 #1123</li>
</ul>
<h2><a href="/zh-CN/components/masker.html">Masker</a></h2>
<ul><li>[feature] 支持通过prop设置是否全屏显示</li>
</ul>
<h2><a href="/zh-CN/components/selector.html">Selector</a></h2>
<ul><li>[fix] 修复Selector不能设置name属性的问题#1133</li>
<li>[enhance] Selector的value支持布尔型. @rbao</li>
</ul>
<h2><a href="/zh-CN/components/swipeout.html">Swipeout</a></h2>
<ul><li>[fix] 修复来回滑动时左侧菜单可能会被滑出 #1139</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[fix] 修复初始化时 value 值为 true 无效的问题 #1138</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.14 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.14-210.vue?35a88c72